import React, { useEffect, useState } from "react";
import { Image } from "primereact/image";
import ICONS from "../Constants/Icons.tsx";
import { Tooltip } from "primereact/tooltip";
import { useMsal } from "@azure/msal-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "primereact/button";
import { useTheme } from '../ThemeContext/ThemeContext.tsx';
import { InteractionStatus } from "@azure/msal-browser";
import { usePermissions } from "../Context/PermissionContext.tsx";
import { PERMISSION_FEATURES, PERMISSION_ACTIONS } from "../Constants/Permissions.ts";
interface Engagement {}

export default function Sidebar() {
  const Icon = ICONS();
  const { instance,inProgress  } = useMsal();
  const location = useLocation();
  const navigate = useNavigate();
  const { isDarkMode, toggleDarkMode } = useTheme();
  const { hasPermission } = usePermissions();
  const canViewAdmin = hasPermission(PERMISSION_FEATURES.ADMIN, PERMISSION_ACTIONS.EDIT) === true;

  const isDarkModeActivated = localStorage.getItem("IsDarkModeActivated");
  const [activeDarkMode, setActiveDarkMode] = useState(
    window.matchMedia("(prefers-color-scheme: dark)").matches
  );

  const [isStaredState, setIsStaredState] = React.useState<boolean>(    location.pathname === "/"
  );
  // eslint-disable-next-line
  const [engagements, setEngagements] = React.useState<Engagement[]>([]);
  const [isActiveRoute, setIsActiveRoute] = React.useState<boolean>(location.pathname === "/engagements");
  const folderIcon = isActiveRoute ? Icon.openFolderIcon : Icon.closeFolderIcon;
  const onDarkmodeClick = () => {
    toggleDarkMode();
  };

  const onActiveEngagementsClick = async () => {
    try {
      navigate("/engagements");
      setIsStaredState(false);
      setIsActiveRoute(true);
    } catch (error) {
      console.error("Failed to load engagements:", error);
    }
  };
   const onRequestsClick = async () => {
    try {
      navigate("/requests");
      setIsStaredState(false);
      setIsActiveRoute(true);
    } catch (error) {
      console.error("Failed to load engagements:", error);
    }
  };

  const onTimeReportClick = async () => {
    try {
      navigate("/time-report");
      setIsStaredState(false);
      setIsActiveRoute(true);
    } catch (error) {
      console.error("Failed to load time report:", error);
    }
  };

  const onAdminClick = async () => {
    try {
      navigate("/admin");
      setIsStaredState(false);
      setIsActiveRoute(true);
    } catch (error) {
      console.error("Failed to load admin:", error);
    }
  };

  const onStarClick = () => {
    setIsStaredState(true);
    setIsActiveRoute(false);
    navigate("/");
  };

  const onLogoutClick = () => {
    // Close the Think panel and clear its history before redirecting
    globalThis.dispatchEvent(new CustomEvent("harmonize-logout"));
    localStorage.setItem("msal-logout", Date.now().toString());
    instance.logoutRedirect();
  };

  const onHelpClick = () => {
    window.open(`${process.env.REACT_APP_THINK_HELP_URL}`, "_blank");
  };

  return (
    <div className="flex position-relative sidebar-container">
      <div className="sidebar mt-6 relative gap-2">
        <Tooltip target=".sidebar-tooltip" />

      
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            onStarClick();
          }}
          className="sidebar-tooltip icon cursor-pointer p-button p-component p-button-icon-only p-button-text p-button-info"
          data-pr-tooltip="Dashboard"
          data-pr-position="right"
          aria-label="Dashboard"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0.20rem",
          }}
        >
          <img src={Icon.HomeIcon} alt="HomeIcon" />
        </a>

        <a
          href="/engagements"
          onClick={(e) => {
            e.preventDefault();
            onActiveEngagementsClick();
          }}
          className="p-button p-button-text p-button-info sidebar-tooltip icon cursor-pointer"
          data-pr-tooltip="Engagement Search"
          data-pr-position="right"
          aria-label="Engagement Search"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0.20rem",
          }}
        >
          <img src={Icon.SearchIcon} alt="SearchIcon" />
        </a>

        <a
          href="/viewrequests"
          onClick={(e) => {
            e.preventDefault();
            onRequestsClick();
          }}
          className="p-button p-button-text p-button-info sidebar-tooltip icon cursor-pointer request-button"
          data-pr-tooltip="View Requests"
          data-pr-position="right"
          aria-label="View Requests"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0.20rem",
          }}
        >
          <img src={Icon.ViewRequestsicon} alt="ViewRequestsicon" />
        </a>

        <a
          href="/time-report"
          onClick={(e) => {
            e.preventDefault();
            onTimeReportClick();
          }}
          className="p-button p-button-text p-button-info sidebar-tooltip icon cursor-pointer request-button"
          data-pr-tooltip="Time Report"
          data-pr-position="right"
          aria-label="Time Report"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center", 
            padding: "0.20rem",
          }}
        >
          <img src={Icon.ClockIcon} alt="TimeReportIcon" />
        </a>

        {canViewAdmin && (
          <a
            href="/admin"
            onClick={(e) => {
              e.preventDefault();
              onAdminClick();
            }}
            className="p-button p-button-text p-button-info sidebar-tooltip icon cursor-pointer request-button"
            data-pr-tooltip="Admin"
            data-pr-position="right"
            aria-label="Admin"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "0.20rem",
            }}
          >
            <img src={Icon.AdminIcon} alt="AdminIcon" />
          </a>
        )}

        <div className="absolute bottom-0 flex-column flex mb-3 gap-2">
          <Button
            icon={<img src={Icon.DarkModeMoon} alt="DarkModeMoon"/>}
            text
            severity="info"
            aria-label={isDarkMode ? "Light mode" : "Dark mode"}
            onClick={onDarkmodeClick}
            className="sidebar-tooltip cursor-pointer"
            data-pr-tooltip={isDarkMode ? "Light mode" : "Dark mode"}
            data-pr-position="right"
          />

          <Button
            icon={<img src={Icon.HelpIcon} alt="HelpIcon" />}
            text
            severity="info"
            aria-label="Help"
            onClick={onHelpClick}
            className="sidebar-tooltip cursor-pointer"
            data-pr-tooltip="Help"
            data-pr-position="right"
          />

          <Button
            icon={<img src={Icon.LogoutIcon} alt="LogoutIcon" />}
            text
            severity="info"
            aria-label="Logout"
            onClick={onLogoutClick}
            className="sidebar-tooltip cursor-pointer"
            data-pr-tooltip="Logout"
            data-pr-position="right"
          />
        </div>
      </div>
    </div>
  );
}
